// Package Imports
import { useEffect } from 'react'

// Core Imports
import { useThemeStore, readStoredTheme } from '@/core/stores/theme.store'

export type { TThemeName } from '@/modules/auth/auth.types'

/**
 * Tema durumuna erişim. State `useThemeStore` (zustand) içinde yaşar ve
 * localStorage'a kalıcıdır (backend persist yok).
 */
export const useTheme = () => {
  const theme = useThemeStore((s) => s.theme)
  const setTheme = useThemeStore((s) => s.setTheme)
  const toggleTheme = useThemeStore((s) => s.toggleTheme)

  return { theme, setTheme, toggleTheme }
}

/**
 * Uygulama kökünde bir kez mount edilir. localStorage'daki tercihle store'u
 * senkronlar ve `document` üzerine `data-theme`'i uygular.
 */
export const useThemeSync = (): void => {
  const theme = useThemeStore((s) => s.theme)
  const setTheme = useThemeStore((s) => s.setTheme)

  useEffect(() => {
    const stored = readStoredTheme()
    if (stored !== theme) setTheme(stored)
  }, [theme, setTheme])

  useEffect(() => {
    if (typeof document === 'undefined') return
    document.documentElement.dataset.theme = theme
  }, [theme])
}
